// extracted by mini-css-extract-plugin
export default {"seo-links-container":"adc__seo-links-container--HBJsR","dropdown-menu":"adc__dropdown-menu--aOQ3v"};